import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ScreeningInvite, EndUserCertification, ScreeningDupeCheckModel } from 'src/app/models/screeningInvite';
import { AuthService } from 'src/app/services/auth.service';
import { PropertyService } from 'src/app/property-module/services/property.service';
import { UserService } from 'src/app/users-module/services/user.service';
import { NgForm } from '@angular/forms';
import { AlternateScoringModel, Client, ClientLocation } from 'src/app/clients-module/models/clientLocation';
import { ClientService } from 'src/app/clients-module/services/client.service';
import { tap, map, switchMap, take } from 'rxjs/operators';
import { CraService } from 'src/app/services/cra.service';
import { ScreeningDraft } from 'src/app/models/screeningDraft';
import { ScreeningDraftService } from '../../services/screening-draft.service';
import { ScreeningService } from '../../services/screening.service';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DOBUpdateModel } from '../dob-dropdowns/dob-dropdowns.component';
// import { _closeDialogVia } from '@angular/material/dialog';
import { PaymentsService } from 'src/app/services/payments.service';
import { PaymentMethod } from 'src/app/models/PaymentModels';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddPaymentMethodModalComponent } from 'src/app/shared-components-module/payments/add-payment-method-modal/add-payment-method-modal.component';
import { getModeForFileReference } from 'typescript';
import { PropertyFilter } from 'src/app/property-module/models/propertyFilter';

@Component({
  selector: 'app-create-applicant-info',
  templateUrl: './create-applicant-info.component.html',
  styleUrls: ['./create-applicant-info.component.less']
})
export class CreateApplicantInfoComponent implements OnInit {
  @ViewChild('appData', {}) ngForm: NgForm;
  locationPmtMethods : PaymentMethod[];
  selectedLocation : ClientLocation;
  
  locationScoringModels: AlternateScoringModel[] = [];

  @Output() public phaseComplete: EventEmitter<number> = new EventEmitter();
  dobModel : DOBUpdateModel;
  public get directOrderDemographics() : ScreeningDraft {
    return this.draftSvc.directOrderDemographics;
  }

  clientList: Client[] = [];

  public get isPOSClient(): boolean {
    if(!this.clientList) return false;
    if(this.directOrderDemographics?.clientId == 0 || this.directOrderDemographics.clientId == undefined) return false;
    if(this.clientList?.filter(c => c.id == this.directOrderDemographics.clientId)[0].billingType == 1) return false;
    return true;
  }
  
  // RIQ-3199 : put the logic in a getter so its easier to extend later.
  public get disableForm() : boolean {
    if(!this.isPOSClient) return false;
    if(this.locationPmtMethods && this.locationPmtMethods.filter(pmt =>{ return pmt.isActive;}).length == 0) return true;
    return false;
  }
  
  toggleClick(val : boolean)
  {
    this.directOrderDemographics.includeIncomeVer = val;
    // console.log('toggle was clicked',this.directOrderDemographics);

  }
 
  constructor(public auth: AuthService,
    public users: UserService,
    public properties: PropertyService,
    public screening : ScreeningService,
    public draftSvc : ScreeningDraftService,
    public cra: CraService,
    private modalService : NgbModal,
    public toast: ToastrService,
    public pmts : PaymentsService,
    public client: ClientService) {
  }

  mapExisting()
  {
    if(this.auth.UserInRole('cra') || this.auth.UserInRole('admin')) 
      this.properties.FetchPropertiesForClient(this.draftSvc.directOrderDemographics.clientId);
    else
      {
        let filt: PropertyFilter = new PropertyFilter();
        this.properties.FetchPropertyList(filt);
        this.fetchScoringModels();
      }
  }

  dobSet($event: DOBUpdateModel){
    console.log('DOB setup CALLED', $event);
    this.dobModel = $event;
    this.directOrderDemographics.dob = $event.dob;
  }

  ngOnInit() {
    this.client.FetchLightClientList().pipe(tap(_ => this.clientList = _.filter(c =>{ return c.isActive;}))).subscribe(
      null,
      ()=>{ this.toast.error('Error loading your client for this draft. If the issue persists please contact support', 'Client load error'); },
      ()=>{ 
        if(this.clientList.length == 1){
          this.directOrderDemographics.clientId = this.clientList[0].id;
          this.mapExisting();
        }
      }
    );
    if(this.draftSvc.directOrderDemographics.id > 0){
      this.fetchScoringModels();
      this.mapExisting();
    }
  }

  clientChange() {
    this.directOrderDemographics.clientLocationId = undefined;
    this.properties.FetchPropertiesForClient(this.directOrderDemographics.clientId);
    this.users.FetchUsersForClient(this.directOrderDemographics.clientId);
  }

  propertyChange(evt: any){
    this.selectedLocation = this.properties.properties.find(p => p.id === evt);
    console.log('PROPERTY SELECT', this.selectedLocation);
    // RIQ-3199: if they select a property and there is no pmt method associated then we need to kill this thing before it gets steam
    // RIQ-3297: only do this check if the current client is POS, ignore for invoicing
    if(this.isPOSClient) {
      this.pmts.FetchPaymentMethods(this.directOrderDemographics.clientLocationId).pipe(take(1),tap(_ =>{
        this.locationPmtMethods = _;
        if(this.locationPmtMethods.filter(pmt =>{ return pmt.isActive;}).length == 0){
            this.toast.error('A valid payment method must be added to your account under account settings in order to run reports. If you are unable to add a payment method please contact your account administrator for assistance','Payment Method Required',{ closeButton: true, timeOut: 60 });
            if(this.auth.UserInRole('Admin') || this.auth.UserInRole('CRA')) this.addPaymentMethod();
        }
      })).subscribe(null,null,()=>{
        // console.log('pmt methods loaded',this.locationPmtMethods);
      });
    }

    this.fetchScoringModels();
  }

  fetchScoringModels(): void {
    this.client.GetAlternativeScoringModelsByLocationId(this.directOrderDemographics.clientLocationId).pipe(tap(_ => {
      this.locationScoringModels = _;
      this.directOrderDemographics.alternativeScoringModelId = this.locationScoringModels.find(e => e.locationDefault == true).id;
    },
    err => {

    },
    () => {


    })).subscribe();
  }

  addPaymentMethod() : void {
    const modalRef = this.modalService.open(AddPaymentMethodModalComponent, { centered: true, size: 'lg' })
    modalRef.componentInstance.name = 'AddPaymentMethodModalComponent';
    modalRef.componentInstance.clientId = this.directOrderDemographics.clientId;
    modalRef.componentInstance.paymentMethodAddFlowComplete.subscribe((evt: PaymentMethod) =>{
      this.locationPmtMethods.push(evt);
    })
  }

  saveAndContinue() {
    if(this.ngForm.valid && !this.dobModel.isMinor && this.directOrderDemographics.certification.ec && this.directOrderDemographics.certification.pp){
      if(this.directOrderDemographics.lastCompletedPhase <= 1) this.directOrderDemographics.lastCompletedPhase = 1;
      this.screening.GetApplicantCountyFromAddressParts(this.directOrderDemographics.street,this.directOrderDemographics.city, this.directOrderDemographics.state)
      .pipe(
        switchMap((_: any) => {this.directOrderDemographics.county = _.county;
          return this.draftSvc.SaveDraft(this.directOrderDemographics)
            .pipe(tap((_: ScreeningDraft) =>{ 
              Object.assign(this.directOrderDemographics,_);
              this.directOrderDemographics.certification.screeningDraftId = _.id;
          }),
          switchMap(_ => this.screening.SaveEndUserCert(this.directOrderDemographics.certification)))      
        })).subscribe(_ => this.phaseComplete.next(1),(err: any)=>{ this.toast.error('Error saving Draft') })
    }
  }
}
